import type { FC } from "react";
import styled from "@emotion/styled";
import { Sparkles, X } from "lucide-react";
import { colors, gradients, radius, spacing } from "../design-tokens";
import { H3 } from "./typographies";
import { ActionButton } from "./action-button";

export type WidgetHeaderProps = {
  title?: string;
  onCloseClick?: () => void;
  showCloseButton?: boolean;
};

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 fit-content;
  width: 100%;
`;

const TitleSection = styled.div`
  display: flex;
  gap: ${spacing.lg}px;
  align-items: center;
  flex: 1;
`;

const HeaderTitle = styled(H3)`
  color: ${colors.primary};
`;

const SparkleIcon = styled(Sparkles)`
  color: ${colors.background};
  fill: ${colors.background};
`;

const SparkleIconContainer = styled.div`
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  ${gradients.headerBackground}
  border-radius: ${radius.full}px;
  padding: ${spacing.sm}px;
`;

export const WidgetHeader: FC<WidgetHeaderProps> = ({
  title = "Pollen AI",
  onCloseClick,
  showCloseButton = false,
}) => {
  return (
    <Header>
      <TitleSection>
        <SparkleIconContainer>
          <SparkleIcon size={24} />
        </SparkleIconContainer>
        <HeaderTitle>{title}</HeaderTitle>
      </TitleSection>

      {showCloseButton && onCloseClick && (
        <ActionButton
          onClick={onCloseClick}
          aria-label="Close modal"
          variant="ghost"
          size="small"
        >
          <X size={20} color={colors.neutralGrey} />
        </ActionButton>
      )}
    </Header>
  );
};
